import {Component, OnInit} from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: '#app-wrapper',
  imports: [RouterOutlet],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css',
  standalone: true,
})
export class AppComponent implements OnInit {
  constructor(private $t: TranslateService) {}

  ngOnInit(): void {
    this.$t.setDefaultLang(
      localStorage.getItem('lang') || this.$t.getDefaultLang(),
    );
    localStorage.setItem(
      'lang',
      localStorage.getItem('lang') || this.$t.getDefaultLang(),
    );

    this.$t.onDefaultLangChange
      .subscribe((res) => localStorage.setItem('lang', res.lang));
  }
}
